export default __webpack_public_path__ + "static/media/wealth3.268c257b.png";